import api from '../../../../utils/api'
import { useState, useEffect } from "react"
import Input from "../../../../shared/components/form/input"
import { useParams } from 'react-router-dom';
import { FaFilter } from 'react-icons/fa'
import { VscClearAll } from 'react-icons/vsc'

import './listServiceExpiration.css'

import { monthToNominal, monthToNominalShort, monthYear, expiratioDateCalc, secondToHMinS } from "../../../../shared/functions/Date"
//import { ExpiratioTimeCalc} from "../../../../shared/functions/ExpirationTimeCalc"
//Modal
import ModalFormServiceExpiration from "../form/ModalFormServiceExpiration"
import HorimetroFilterModal, { FILTER_OPTIONS } from "./HorimetroFilterModal"

//Hooks
import useMyPermission from '../../../../hooks/useMyPermission'

//image
import iconMaterial from '../../img/iconMaterialBest.png'
import iconEmergencia from '../../img/iconEmergencia.png'
import iconHorario from '../../img/iconHorario.png'
import iconManuValida from '../../img/iconManuValida.png'
import iconManuVencida from '../../img/iconManuVencida.png'
import iconCritical from '../../img/iconCritical.png'
import iconNoNotification from '../../img/iconNoNotification.png'

function getDate() {
    const today = new Date()
    const month = today.getMonth() + 1
    const year = today.getFullYear()

    return `${year}-${month}`;
}

function ListServiceExpiration({ filter }) {
    const { notificationFilter } = useParams()
    let notificationObj
    if (notificationFilter) {
        notificationObj = FILTER_OPTIONS.find((item) => item.value === notificationFilter)

    }

    const [token] = useState(localStorage.getItem('token') || '')
    const [listClient, setListClient] = useState([])
    const [inputFilter, setInputFilter] = useState("")
    const [selectedFilter, setSelectedFilter] = useState(notificationObj || { value: "", label: "Sem filtro" })
    const [modalFilter, setModalFilter] = useState(false)
    const [modalClientServicesExpiration, setModalClientServicesExpiration] = useState(false)
    const [dataModalClientServicesExpiration, setDataModalClientServicesExpiration] = useState({})
    const [currentDate, setCurrentDate] = useState(new Date().getTime())

    const [myPermission, setMyPermission] = useState({ group: "", })

    useEffect(() => {
        getAllClientData()
    }, [token])

    async function getAllClientData() {
        api.get('/clientServiceExpiration/getallclientservices', {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        })
            .then((response) => {
                setMyPermission(response.data.permission)
                setListClient(response.data.clients)
            })
    }
    const updateDataClient = () => {
        getAllClientData()
    }

    const handleOnSelectChange = (selectedOption) => {
        setSelectedFilter(selectedOption)
        setModalFilter(false)
    }

    const clearFilter = () => {
        setSelectedFilter({ value: "", label: "Sem filtro" })
        setModalFilter(false)
    }
    //-------------------- FILTER ---------------------------------------------------
    let tableFilter = []
    if (filter !== "") {

        tableFilter = listClient.filter((item) => item.region === filter)
        const searchLowerCase = inputFilter.toLowerCase()
        tableFilter = tableFilter.filter((item) => item.name.toLowerCase().includes(searchLowerCase));

        if (tableFilter.length == 0) {
            tableFilter = []

        }

    } else {
        const searchLowerCase = inputFilter.toLowerCase()
        tableFilter = listClient.filter((item) => item.name.toLowerCase().includes(searchLowerCase));
        if (tableFilter.length == 0) {
            tableFilter = []

        }
    }
    if (selectedFilter !== "") {
        if (selectedFilter.value === "all") {
            tableFilter = tableFilter.filter((item) => anyExpire(item))
        } else if (selectedFilter.value == "critical") {
            tableFilter = tableFilter.filter((item) => expirationFilter(item.critical))
            tableFilter = tableFilter.filter((item) => anyExpire(item))
        } else if (selectedFilter.value == "radiator") {
            tableFilter = tableFilter.filter((item) => expirationFilter(item.nextInspectionRadiatorDate))
        } else if (selectedFilter.value == "injectionPump") {
            tableFilter = tableFilter.filter((item) => expirationFilter(item.nextInspectionInjectionPumpDate))
        } else if (selectedFilter.value == "tankCleaning") {
            tableFilter = tableFilter.filter((item) => expirationFilter(item.nextTankCleaningDate))
        } else if (selectedFilter.value == "alternatorMegage") {
            tableFilter = tableFilter.filter((item) => expirationFilter(item.nextAlternatorMegageDate))
        } else if (selectedFilter.value == "equipmentSanitization") {
            tableFilter = tableFilter.filter((item) => expirationFilter(item.nextEquipmentSanizationDate))
        } else if (selectedFilter.value == "changeBattery") {
            tableFilter = tableFilter.filter((item) => expirationFilter(item.nextChangeBatteryDate))
        } else if (selectedFilter.value == "oilAndFilter") {
            tableFilter = tableFilter.filter((item) => expirationFilterHorimetro(item))
        } else if (selectedFilter.value == "-all") {
            tableFilter = tableFilter.filter((item) => anyCloseExpire(item))
        }
    }


    function myFilter(e) {
        setInputFilter(e.target.value)


    }
    //-------------------------------------------------------------------------------------





    function OpenModalClientServicesExpiration(data) {
        setDataModalClientServicesExpiration(data)
        setModalClientServicesExpiration(true)
    }
    function anyExpire(item) {
        let expHorNumber = 900000
        if ((new Date(item.nextInspectionRadiatorDate).getTime()) <= currentDate) {
            return true
        } else if ((new Date(item.nextInspectionInjectionPumpDate).getTime()) <= currentDate) {
            return true
        } else if ((new Date(item.nextTankCleaningDate).getTime()) <= currentDate) {
            return true
        } else if ((new Date(item.nextAlternatorMegageDate).getTime()) <= currentDate) {
            return true
        } else if ((new Date(item.nextEquipmentSanitizationDate).getTime()) <= currentDate) {
            return true
        } else if ((new Date(item.nextChangeBatteryDate).getTime()) <= currentDate) {
            return true
        } else if ((new Date(item.nextHorimetroChangeOilAndFilterDate).getTime()) <= currentDate) {
            return true
        } else if (expHorNumber <= parseInt(item.totalLastHorimetroChangeOilAndFilterRecordSeconds)) {
            return true
        } else {
            return false
        }

    }
    function anyCloseExpire(item) {
        let expHorNumber = 809000
        if (((new Date(item.nextInspectionRadiatorDate).getTime()) >= currentDate) && (((new Date(item.nextInspectionRadiatorDate).getTime()) - currentDate) <= 2592000000)) {
            return true
        } else if ((new Date(item.nextInspectionInjectionPumpDate).getTime()) >= currentDate && (((new Date(item.nextInspectionInjectionPumpDate).getTime()) - currentDate) <= 2592000000)) {
            return true
        } else if ((new Date(item.nextTankCleaningDate).getTime()) >= currentDate && (((new Date(item.nextTankCleaningDate).getTime()) - currentDate) <= 2592000000)) {
            return true
        } else if ((new Date(item.nextAlternatorMegageDate).getTime()) >= currentDate && (((new Date(item.nextAlternatorMegageDate).getTime()) - currentDate) <= 2592000000)) {
            return true
        } else if ((new Date(item.nextEquipmentSanitizationDate).getTime()) >= currentDate && (((new Date(item.nextEquipmentSanitizationDate).getTime()) - currentDate) <= 2592000000)) {
            return true
        } else if ((new Date(item.nextChangeBatteryDate).getTime()) >= currentDate && (((new Date(item.nextChangeBatteryDate).getTime()) - currentDate) <= 2592000000)) {
            return true
        } else if ((new Date(item.nextHorimetroChangeOilAndFilterDate).getTime()) >= currentDate && (((new Date(item.nextHorimetroChangeOilAndFilterDate).getTime()) - currentDate) <= 2592000000)) {
            return true
        } else {
            return false
        }

    }
    function expiration(expDate) {
        let expDateTime = new Date(expDate).getTime()
        if (expDate) {

            if (expDateTime <= currentDate) {
                return "service-expiration-color-red"
            } else if (((expDateTime - currentDate) >= 0) && ((expDateTime - currentDate) <= 2592000000)) {
                return "service-expiration-color-yellow"
            }

        }
    }

    function expirationCritical(item) {
        if (item.critical) {

            if (anyExpire(item)) {
                return "service-expiration-color-critical box-tr"
            }
        }
        return "box-tr"

    }
    function expirationFilter(expDate) {
        let expDateTime = new Date(expDate).getTime()
        if (expDate) {

            if (expDateTime <= currentDate) {
                return true
            }

        }
    }
    function expirationFilterHorimetro(item) {
        let expHorNumber = 900000
        if ((new Date(item.nextHorimetroChangeOilAndFilterDate).getTime()) <= currentDate) {
            return true
        } else if (expHorNumber <= parseInt(item.totalLastHorimetroChangeOilAndFilterRecordSeconds)) {
            return true

        }
    }

    function expirationHorimetro(expHor) {
        let expHorNumber = 900000


        if (expHor) {
            if (expHorNumber <= parseInt(expHor)) {
                return "service-expiration-color-red"
            }
        }
    }
    const visibleRows = tableFilter.filter((item) => item.disabled !== true)

    return (

        <section className='list-service-expiration-container'>
            <div className="hor-sticky-top">
                <div className="hor-header">
                    <div className="hor-header-title">
                        <p className="pg-title">Serviços e Prazos</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-right">
                        <button
                            className={`pg-filter-btn ${selectedFilter.value !== "" ? 'pg-filter-btn-active' : ''}`}
                            onClick={() => setModalFilter(true)}
                        >
                            <FaFilter size={13} />
                            <span>Filtrar</span>
                            {selectedFilter.value !== "" && <span className="pg-filter-dot" />}
                        </button>
                        <div className="pg-search">
                            <Input
                                type="text"
                                name="filterTable"
                                placeholder="Buscar gerador..."
                                value={inputFilter}
                                handleOnChange={myFilter}
                            />
                        </div>
                        <span className="pg-count">
                            {visibleRows.length} {visibleRows.length === 1 ? 'gerador' : 'geradores'}
                        </span>
                    </div>
                </div>

                {selectedFilter.value !== "" && (
                    <div className="pg-filter-active-bar">
                        <span className="pg-filter-active-dot" />
                        <span className="pg-filter-active-label">Filtro ativo</span>
                        <span className="pg-filter-active-count">{selectedFilter.label}</span>
                        <button className="pg-filter-active-clear" onClick={clearFilter}>
                            <VscClearAll size={14} />
                            Limpar
                        </button>
                    </div>
                )}
            </div>

            <div className="hor-table-wrap">
                <table className="hor-table">
                    <thead>
                        <tr>
                            <th className="hor-th-first">Modo de operação</th>
                            <th className='hor-th-client'>Gerador</th>
                            <th>Radiador Sist. Arr.</th>
                            <th>Revisão de bomba injetora</th>
                            <th>Limpeza de tanque</th>
                            <th>Troca de bateria</th>
                            <th>Megagem de alternador</th>
                            <th>Higienização de equipamento</th>
                            <th>Data da próxima revisão</th>
                            <th className="hor-th-last">Horas funcionadas após última revisão</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleRows.length > 0 ? (
                            visibleRows.map((item) => (
                                <tr key={item._id} className={expirationCritical(item)} onClick={() => { OpenModalClientServicesExpiration(item) }}>
                                    {/* OPERATION MODE */}
                                    <td>
                                        <div className="hor-operation-icons">
                                            {item.emergency && <img className="operation-mode-icon" src={iconEmergencia} alt="Emergência" title="Emergência" />}
                                            {anyExpire(item) ? (<img className="operation-mode-icon" src={iconManuVencida} alt="Manutenção vencida" title="Manutenção vencida" />) : (<img className="operation-mode-icon" src={iconManuValida} alt="Manutenção válida" title="Manutenção válida" />)}
                                            {item.materialBest && (<img className="operation-mode-icon" src={iconMaterial} alt="Material fornecido" title="Material fornecido pela Bestforce" />)}
                                            {item.rushHour && <img className="operation-mode-icon" src={iconHorario} alt="Horário de ponta" title="Horário de ponta" />}
                                            {item.critical && <img className="operation-mode-icon" src={iconCritical} alt="Gerador crítico" title="Gerador crítico" />}
                                            {item.noNotification && <img className="operation-mode-icon" src={iconNoNotification} alt="Notificações desabilitadas" title="Notificações desabilitadas" />}
                                        </div>
                                    </td>

                                    <td className="hor-td-client">{item.name}</td>
                                    <td className={expiration(item.nextInspectionRadiatorDate)}>{item.nextInspectionRadiatorDate ? monthYear(item.nextInspectionRadiatorDate) : "----------"}</td>
                                    <td className={expiration(item.nextInspectionInjectionPumpDate)}>{item.nextInspectionInjectionPumpDate ? monthYear(item.nextInspectionInjectionPumpDate) : "----------"}</td>
                                    <td className={expiration(item.nextTankCleaningDate)}>{item.nextTankCleaningDate ? monthYear(item.nextTankCleaningDate) : "----------"}</td>
                                    <td className={expiration(item.nextChangeBatteryDate)}>{item.nextChangeBatteryDate ? monthYear(item.nextChangeBatteryDate) : "----------"}</td>
                                    <td className={expiration(item.nextAlternatorMegageDate)}>{item.nextAlternatorMegageDate ? monthYear(item.nextAlternatorMegageDate) : "----------"}</td>
                                    <td className={expiration(item.nextEquipmentSanitizationDate)}>{item.nextEquipmentSanitizationDate ? monthYear(item.nextEquipmentSanitizationDate) : "----------"}</td>
                                    <td className={expiration(item.nextHorimetroChangeOilAndFilterDate)}>{item.nextHorimetroChangeOilAndFilterDate ? monthYear(item.nextHorimetroChangeOilAndFilterDate) : "----------"}</td>
                                    <td className={expirationHorimetro(item.totalLastHorimetroChangeOilAndFilterRecordSeconds)}>{item.totalLastHorimetroChangeOilAndFilterRecordSeconds ? `${secondToHMinS(item.totalLastHorimetroChangeOilAndFilterRecordSeconds)}` : "----------"}</td>
                                </tr>
                            ))
                        ) : (
                            <tr className="hor-tr-empty">
                                <td colSpan="10">Sem registro</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {modalClientServicesExpiration &&
                <ModalFormServiceExpiration myPermission={myPermission} updateData={updateDataClient} clientData={dataModalClientServicesExpiration} listClient={listClient} closeModal={() => { setModalClientServicesExpiration(false) }} />
            }

            {modalFilter &&
                <HorimetroFilterModal
                    selectedFilter={selectedFilter}
                    onChange={handleOnSelectChange}
                    onClear={clearFilter}
                    onClose={() => setModalFilter(false)}
                />
            }

        </section>

    )

}

export default ListServiceExpiration